import React from 'react';
import { StringField } from '../../../types/types';

export type TPrivacyContentFieldItem = {
  id: string;
  name: string;
  displayName: string;
  fields: {
    contentDetail?: StringField;
    accordionContentTitle?: StringField;
    accordionContentDetail?: StringField;
    templateId: string;
  }
}

export type TPrivacyContentItems = {
  id: string;
  name: string;
  displayName: string;
  fields: {
    anchorContentTitle: StringField;
    templateId: string;
    items: TPrivacyContentFieldItem[];
  }
};

export type TPrivacyContent = {
  privacyStatementTitle: StringField;
  languageTitle: StringField;
  changeLanguageTitle: StringField;
  templateId: string;
  items: TPrivacyContentItems[];
};

export type TLanguageCollection = {
  [x: string]: string;
}

export type TTypeCollection = {
  [x: string]: string[];
}

export type TPrivacyStatementFields = {
  languageTitle: StringField;
  defaultEmptyMessage: StringField;
  languageCollection: Array<TLanguageCollection>;
  typeCollection: Array<TTypeCollection>;
  privacyContent: TPrivacyContent;
  typeTitle: StringField;
};

export type TPrivacyStatementProps = {
  componentName?: string;
  fields?: TPrivacyStatementFields;
  activeItem?: number;
  setActiveItem?: React.Dispatch<React.SetStateAction<number>>
};

export enum InnerContentTypes {
  RichText = "{00184BDC-5736-410C-8EF0-CEE6081ED672}",
  Accordion = "{AF5D46F5-BFF0-4235-84BC-4AC98C1CA038}",
}

export type TDropdownProps = {
  Collection: string[];
  changeTitle: string;
  defaultTitle: string;
  onSelect:React.Dispatch<React.SetStateAction<string | null>>;
  preSelected: string;
}

export type TAccordionProps = {
  accordionContentTitle?: StringField;
  accordionContentDetail?: StringField;
}

export type TSectionTabsProps = {
  contentWrapperRef:  React.MutableRefObject<HTMLDivElement | null>;
  privacyContentItems: TPrivacyContentItems[];
}

export type TMobileNavigationBarProps = {
  privacyContentItems: TPrivacyContentItems[];
}
